import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Top-level await (S7785) is not usable here: zone.js disables native
// async/await downleveling in the esbuild pipeline, so the build rejects
// top-level await while the app is zone-based.
bootstrapApplication(AppComponent, appConfig) // NOSONAR
  .catch(err => console.error(err));
